import { HttpStatusCode } from '@angular/common/http';

export class ApiError extends Error {
  constructor(
    message: string,
    public readonly status?: number,
    public readonly url?: string | null,
    public readonly fieldErrors?: Record<string, string[]>,
    /** The server's machine-readable reason, e.g. `already_submitted`, when it sends one. */
    public readonly code?: string,
  ) {
    super(message);
    this.name = 'ApiError';
  }
}

export function hasStatus(err: unknown, status: HttpStatusCode): boolean {
  return err instanceof ApiError && err.status === status;
}
